module.exports = __webpack_public_path__ + "static/media/facebookIcon.d2a9c8ef.svg";